import { FORM_DATATYPES, TpAutoFormDef } from '../../../../components/auto-form-modal/AutoForm';
import { ViewStateMetadata } from '../../../../api/models/apis';
import { VISIBILITY_CONFIG } from '../constants/visibility-config';
import { VIEW_STATE_TERMS } from '../../../../data/snapshot/dashboardStateSerialization';

interface SaveViewStateFormOptions {
  close: () => void;
  saveViewState: (name: string, description: string | null, visibility: string) => Promise<string>;
  activeViewStateId: string | null;
  viewStates: ViewStateMetadata[];
}

/**
 * Returns the form definition for saving a dashboard state.
 */
export function saveViewStateForm({
  close,
  viewStates,
  saveViewState,
  activeViewStateId,
}: SaveViewStateFormOptions): TpAutoFormDef {
  const activeViewState = viewStates.find((viewState) => viewState.id === activeViewStateId);
  const initialName = activeViewState ? `${activeViewState.name} (Copy)` : '';

  const form: TpAutoFormDef = {
    title: `Save ${VIEW_STATE_TERMS.singular}`,
    fields: [
      {
        id: 'name',
        name: 'Name',
        dataType: FORM_DATATYPES.STRING,
        startContent: initialName,
        required: true,
        inputValidation: (content) => {
          const name = String(content).trim();
          return name.length > 0 && name.length <= 255;
        },
        ValidationMessage: 'Name must contain between 1 and 255 characters.',
        inputWarning: (content) => {
          const name = String(content).trim().toLowerCase();
          return !!name && viewStates.some((viewState) => viewState.name.trim().toLowerCase() === name);
        },
        WarningMessage: `A ${VIEW_STATE_TERMS.singular} with this name already exists.`,
      },
      {
        id: 'description',
        name: 'Description',
        dataType: FORM_DATATYPES.STRING,
        startContent: activeViewState?.description || '',
        lineCount: 4,
      },
      {
        id: 'visibility',
        name: 'Visibility',
        dataType: FORM_DATATYPES.MULTIPLECHOICE,
        startContent: 'private',
        choices: Object.entries(VISIBILITY_CONFIG).map(([id, config]) => ({
          id,
          content: config.label,
        })),
        required: true,
      },
    ],
    submit: async (formData) => {
      await saveViewState(
        String(formData.name).trim(),
        String(formData.description).trim() || null,
        formData.visibility,
      );
      close();
    },
  };

  return form;
}
